import React from 'react';
import PropTypes from 'prop-types';
import { Button, TextInput, StackView, Notification, Typography } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import { Spacer } from '../../../help/styles';
import Modal from '../../../design/shared/modal';
import { popupStyles } from './styles';

const Promotions = ({ promotions, setPromotions }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [promotionCode, setPromotionCode] = React.useState('');
  const [validationCode, setvalidationCode] = React.useState('');
  const [validationError, setValidationError] = React.useState('');

  const isAddAllowed = promotions.length < 8;

  const openModal = () => {
    if (isAddAllowed) {
      setShowModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const resetFields = () => {
    setPromotionCode('');
    setvalidationCode('');
  };

  const addPromotion = () => {
    setPromotions([...promotions, { promotionCode, validationCode }]);
    resetFields();
    closeModal();
  };

  const areFieldsValid = () => {
    if (promotionCode) {
      setValidationError('');
      return true;
    }
    setValidationError('Please enter promotion code to continue');
    return false;
  };

  const onAdd = () => {
    if (areFieldsValid()) {
      addPromotion();
    }
  };

  const onDelete = index => {
    setPromotions([
      ...promotions.slice(0, index),
      ...promotions.slice(index + 1)
    ]);
  };

  return (
    <div className="table-responsive">
      {!!promotions.length && (
        <table className="table table-bordered table-hover">
          <thead style={{ backgroundColor: '#f2f2f2' }}>
            <tr>
              <th scope="col"><Typography>Promotion code</Typography></th>
              <th scope="col"><Typography>Validation code</Typography></th>
              <th><Typography>Remove</Typography></th>
            </tr>
          </thead>
          {promotions.map((promotion, index) => (
            <tbody key={promotion.promotionCode}>
              <tr>
                <td><Typography>{promotion.promotionCode}</Typography></td>
                <td><Typography>{promotion.validationCode || '-'}</Typography></td>
                <td>
                  <Button
                    icon={Delete}
                    onPress={() => onDelete(index)}
                    accessibilityLabel="Delete"
                    variant={{ text: true }}
                  />
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      )}
      <StackView space={4}>
        {!isAddAllowed && (
          <Notification variant={{ validation: 'warning' }} copy="en">
            <Typography variant={{ bold: true }}>
              8/8 promotions added, delete a promotion to add another.
            </Typography>
          </Notification>
        )}
        <Button onClick={openModal}>Add Promotion</Button>
      </StackView>
      <Modal
        open={showModal}
        setOpen={closeModal}
        customStyles={popupStyles}
        header="Add Promotion"
      >
        <StackView space={4}>
          {validationError && (
            <Notification variant={{ validation: 'error' }} copy="en">
              <Typography variant={{ bold: true }}>{validationError}</Typography>
            </Notification>
          )}
          <TextInput
            label="Promotion Code*"
            value={promotionCode || ''}
            onChange={(value) => {
              setPromotionCode(value);
            }}
          />
          <TextInput
            label="Validation code (Leave blank if not applicable)"
            value={validationCode || ''}
            onChange={(value) => {
              setvalidationCode(value);
            }}
          />
          <Button onClick={onAdd}>Add</Button>
        </StackView>
      </Modal>
      <Spacer />
    </div>
  );
};

Promotions.propTypes = {
  promotions: PropTypes.arrayOf({
    promotionCode: PropTypes.string,
    validationCode: PropTypes.string
  }).isRequired,
  setPromotions: PropTypes.func.isRequired
};

export default Promotions;
